import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

/**
 * Consistent centered loading indicator + label. Presentation only.
 */
const LoadingState = ({ label = 'Loading…', compact = false, sx }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 1.5,
        py: compact ? 3 : 8,
        ...sx,
      }}
    >
      <CircularProgress size={compact ? 22 : 28} thickness={4} />
      {label && (
        <Typography variant="body2" color="text.secondary">
          {label}
        </Typography>
      )}
    </Box>
  );
};

export default LoadingState;
